export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-dark text-white py-8 sm:py-12">
      <div className="container px-4 sm:px-6">
        <div className="flex flex-col items-center space-y-6">
          <div className="text-center">
            <div className="flex items-center justify-center mb-2">
              <img src="/images/logo/logo.png" alt="InfluenceHub Logo" className="h-5 sm:h-6 w-auto mr-2" />
              <span className="text-lg sm:text-xl font-bold text-white font-display">InfluenceHub</span>
            </div>
            <p className="text-gray-400 text-xs sm:text-sm font-dm-sans">© {currentYear} InfluenceHub. All rights reserved.</p>
          </div>
          <div className="flex flex-col items-center space-y-3 text-center">
            {/* First Row: Main navigation (match Website index.html) */}
            <div className="flex flex-wrap justify-center items-center gap-x-4 md:gap-x-6 gap-y-2">
              <a href="/what-is-an-influencer-profile" className="text-gray-300 hover:text-white transition-colors font-dm-sans text-sm sm:text-base min-h-[44px] flex items-center whitespace-nowrap">What is an influencer profile?</a>
              <a href="/create-influencer-profile" className="text-gray-300 hover:text-white transition-colors font-dm-sans text-sm sm:text-base min-h-[44px] flex items-center whitespace-nowrap">How to create your profile</a>
              <a href="/media-kit-guide" className="text-gray-300 hover:text-white transition-colors font-dm-sans text-sm sm:text-base min-h-[44px] flex items-center whitespace-nowrap">Media kit guide</a>
            </div>
            {/* Second Row: Legal & Contact */}
            <div className="flex flex-wrap justify-center items-center gap-x-4 md:gap-x-6 gap-y-2">
              <a href="/privacy" className="text-gray-300 hover:text-white transition-colors font-dm-sans text-sm sm:text-base min-h-[44px] flex items-center whitespace-nowrap">Privacy Policy</a>
              <a href="/terms" className="text-gray-300 hover:text-white transition-colors font-dm-sans text-sm sm:text-base min-h-[44px] flex items-center whitespace-nowrap">Terms of Service</a>
              <a href="mailto:hello@influencehub.net" className="text-gray-300 hover:text-white transition-colors font-dm-sans text-sm sm:text-base min-h-[44px] flex items-center break-all">hello@influencehub.net</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
